import PublicationCreatePet from './PublicationCreatePet';
import SelectLocation from './SelectLocation';
import PetCategories from './PetCategories';
import PetProfile from './PetProfile';
import PublicationPreview from './PublicationPreview';
import PublicationPreviewAvatar from './PublicationPreviewAvatar';
import PublicationSliderGallery from './PublicationSliderGallery';
import PetFilters from './PetFilters';
import PublicationEdit from './PublicationEdit';
import PublicationSuccess from './PublicationSuccess';

const createPetWithoutDonations = [
    {
        title: 'publication_pet_choose_ad_category',
        progress: { title: 'publication_pet_progress_category', step: 2, },
        component: PublicationCreatePet, valid: true, required: true,
    },
    {
        title: 'publication_pet_location',
        progress: { title: 'publication_pet_progress_region', step: 3 },
        component: SelectLocation, valid: true, required: true,
    },
    {
        title: 'publication_pet_choose_category',
        progress: { title: 'publication_pet_progress_category', step: 4 },
        component: PetCategories, valid: true, required: true,
    },
    {
        title: 'publication_pet_enter_pet_data',
        progress: { title: 'publication_pet_progress_enter_data', step: 5 },
        component: PetProfile, valid: true, required: true,
    },
    {
        title: 'publication_pet_enter_ad_text',
        progress: { title: 'publication_pet_progress_ad_text', step: 6 },
        component: PublicationPreview, valid: true, required: true,
    },
    {
        title: 'publication_pet_upload_profile_photo',
        progress: { title: 'publication_pet_progress_profile_photo', step: 7 },
        component: PublicationPreviewAvatar, valid: true, required: true,
    },
    {
        title: 'publication_pet_upload_gallery_photos',
        progress: { title: 'publication_pet_progress_ad_photos', step: 8 },
        component: PublicationSliderGallery, valid: true, required: true,
    },
    {
        title: 'publication_pet_additional',
        progress: { title: 'publication_pet_progress_additional', step: 9 },
        subtitle: 'publication_pet_additional_optional',
        component: PetFilters, valid: true, required: false,
    },
    {
        title: 'publication_pet_check_entered_data',
        progress: { title: 'publication_pet_progress_check_data', step: 10 },
        component: PublicationEdit, valid: true, required: true,
    },
    {
        progress: { title: 'publication_pet_progress_thanks', step: 11 },
        component: PublicationSuccess, valid: true, required: true,
    },
];

export default createPetWithoutDonations;
